<odx-tab-bar (selectedTabChanged)="selectedTabIndex.set($event.selectedIndex)">
  <odx-tab-bar-item i18n="@@floorplan.details.plasticSign.tabBar.tab1">Beschriftung</odx-tab-bar-item>
  <odx-tab-bar-item i18n="@@floorplan.details.plasticSign.tabBar.tab2">Produkte</odx-tab-bar-item>
</odx-tab-bar>

@if (selectedTabIndex() === 0) {
  <div odxLayout="flex" class="flex-column">
    <h5 i18n="@@floorplan.details.plasticSign.title" class="odx-title-5">Beschriftung</h5>
    <div odxLayout="flex gap-none" class="flex-column">
      <div class="feature">
        <p class="odx-text--small" i18n="@@floorplan.details.plasticSign.text">Text</p>
        <p class="odx-text">{{ plasticSign().config.text }}</p>
      </div>
      <div class="feature">
        <p class="odx-text--small" i18n="@@floorplan.details.plasticSign.textColor">Textfarbe</p>
        <p class="odx-text">{{ plasticSign().config.textColor }}</p>
      </div>

      <div class="feature">
        <p class="odx-text--small" i18n="@@floorplan.details.plasticSign.backgroundColor">Hintergrundfarbe</p>
        <p class="odx-text">{{ plasticSign().config.backgroundColor }}</p>
      </div>
    </div>
  </div>
}
@if (selectedTabIndex() === 1) {
  <app-floorplan-custom-part-numbers [floorplanItem]="plasticSign()"></app-floorplan-custom-part-numbers>
}
